import dayjs from "dayjs";
import { TransactionFlowRecordFilterType } from "../graphql/types/TransactionFlowRecordType";
import { AccountTransactionFlowFilterType } from "../graphql/types/AccountTransactionFlowType";
import { VirtualAccountFilterType } from "../graphql/types/VirtualAccountType";
import { RealtimeSettlementOrderDailySumFilterType } from "../graphql/types/RealtimeSettlementOrderDailySumType";

/** 默认时间：当天（YYYY-MM-DD 字符串范围） */
export const todayDateRange = (): [string, string] => {
    const today = dayjs().format('YYYY-MM-DD');
    return [today, today];
};

export const TransactionFlowRecordFilterInitialValue = (): TransactionFlowRecordFilterType => ({
    transactionType: undefined,
    transactionResult: undefined,
    businessId: undefined,
    transactionNo: undefined,
    transactionTime: todayDateRange(),
    timeZoneId: undefined,
    clientId: undefined,
    bizOrderNo: undefined,
});

export const AccountTransactionFlowFilterInitialValue = (): AccountTransactionFlowFilterType => ({
    virtualAccountId: undefined,
    transactionTime: todayDateRange(),
});

export const VirtualAccountFilterInitialValue: VirtualAccountFilterType = {
    virtualAccountId: undefined,
    clientId: undefined,
};

export const RealtimeSettlementOrderDailySumFilterInitialValue = (): RealtimeSettlementOrderDailySumFilterType => ({
    clientIds: undefined,
    dailyDateStart: dayjs().format('YYYYMMDD'),
    dailyDateEnd: dayjs().format('YYYYMMDD'),
});

export const transactionTypeOptions = [
    { label: '代扣交易', value: '1' },
    { label: '调账交易', value: '2' },
    { label: '退款交易', value: '3' },
    { label: '调账-赔付', value: '7' },
];

export const transactionResultOptions = [
    { label: '成功', value: 'SUCCESS' },
    { label: '失败', value: 'FAILED' },
];

export const currencyOptions = [
    { label: '美元', value: 'USD' },
    { label: '人民币', value: 'CNY' },
];

